/**
 * Display helpers for Key Findings bullets — shortens verbose inline
 * `[Doc folder/…/file.pdf]` paths so derived claim text reads cleanly.
 */
export function normalizeFindingCitationNoise(text: string): string {
  if (!text) return '';
  let out = text;
  // `[Doc path/to/file.pdf]` → *(per "file.pdf")* (matches narrative convention)
  out = out.replace(/\[Doc\s+[^\]]+\/([^/\]]+\.\w+)\]/gi, (_m, file: string) => `*(per "${file}")*`);
  out = out.replace(/\[Doc\s+([^\]]+)\]/gi, (_m, path: string) => {
    const file = path.split('/').pop()?.trim() ?? path.trim();
    return `*(per "${file}")*`;
  });
  return out.replace(/\s{2,}/g, ' ').trim();
}

/** Split narrative prose into paragraph blocks on blank lines. */
export function splitNarrativeParagraphs(text: string): string[] {
  return text
    .split(/\n\s*\n/)
    .map(p => p.trim())
    .filter(Boolean);
}
